import { Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import AlertNew from '../../commons/dialogs/AlertNew';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import AdaugaClientNou from './AdaugaClientNou';
import ClientiRowsFinanciar from './ClientiRowsFinanciar';


export default class ClientiRows extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            clientiH: {},
            clientiRows: [],
            adaugaClient: false,
            numeClient: '',
            alertView:false
        }
    }

    ws = new Ws();
    u = new Utils();
    ls = new LocalStorage().GetUserData()


    componentDidMount() {
        this.access()
        this.getData()
    }


    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.AccessFinanciar === 1 ? false : true })
        }


    }

    getData = async () => {





        let getClienti = await this.ws.customSelect('select * from fin_import_raport_lunar_clienti_head where id = @p1', {
            p1: this.props.match.params.idClientiHead
        })

        console.log('getClienti :>> ', getClienti);

        if (getClienti.Succes) {

            let clientiH = { ...getClienti.Content[0] }







            let clientiRows = await this.ws.customSelect('select * from fin_import_raport_lunar_clienti_rows where id_head = @p1', {
                p1: clientiH.id
            })




            if (clientiRows.Succes) {

                let clientiR = [...clientiRows.Content]


                let clienti = [...new Set(clientiR.map(c => c.localitate))]


                let clientiNew = []


                for (let i = 0, n = clienti.length; i < n; i++) {


                    let idxClient = clientiR.findIndex(c => c.localitate === clienti[i])

                    console.log('idxClient :>> ', idxClient);

                    let client = {
                        id: clientiR[idxClient]['id'],
                        nume: clienti[i],
                        facturi: 0,
                        sold: 0
                    }
                    

                    client['facturi'] = clientiR.filter(c => (c.document && c.document.length > 0) && c.localitate === clienti[i]).length

                    let filterClienti = clientiR.filter(c => c.localitate === clienti[i])

                    for (let j = 0, n = filterClienti.length; j < n; j++) {

                        if (filterClienti[j].document && filterClienti[j].document.length > 0) {
                            client['sold'] += filterClienti[j].valoare
                        }
                    }

                    client.sold = this.u.toFixedIfNecessary(client.sold, 2)

                    clientiNew.push(client)
                }

                console.log('clientiNew :>> ', clientiNew);


                this.setState({
                    clientiH: clientiH,

                    clientiRows: clientiNew
                })



            }

        }


    }


    addClient = async () => {

        let client = { localitate: this.state.numeClient, id_head: this.props.match.params.idClientiHead, valoare: 0, document: '' }

        console.log('client :>> ', client);

        let insertClient = await this.ws.insert('fin_import_raport_lunar_clienti_rows', client)


        if (insertClient.Succes) {
            this.props.history.push(`/datedespreclient/${insertClient.Content[0].id}`)
        }

    }


    editClienti = (c) => {

        console.log('c :>> ', c);
        this.props.history.push(`/datedespreclient/${c.id}`)
    }

    inapoi = () => {
        this.props.history.goBack()
    }


    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title='' />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />

                <Grid style={{ maxWidth: 1200, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.financiar.clienti} in {this.state.clientiH.an} </h1>
                    </Grid>

                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                            {!this.state.adaugaClient &&
                                <ClientiRowsFinanciar
                                    clientiRows={this.state.clientiRows}
                                    addClient={() => { this.setState({ adaugaClient: true }) }}
                                    editClienti={this.editClienti}
                                    anul={this.state.clientiH.an}
                                    inapoi={this.inapoi} />

                            }


                            {this.state.adaugaClient &&

                                <AdaugaClientNou
                                    clientNume={this.state.numeClient}
                                    changeNumeClient={(ev) => { this.setState({ numeClient: ev.target.value }) }}
                                    dictionary={this.dictionary}
                                    addClient={this.addClient}
                                    anul={this.state.clientiH.an}
                                    inapoi={() => { this.setState({ adaugaClient: false }) }}

                                />


                            }


                        </Grid>

                        {!this.state.adaugaClient &&

                            <Grid item style={{ textAlign: 'left', paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                <div style={{ display: 'flex', justifyContent: "space-between", backgroundColor: 'rgb(114 227 254)', borderRadius: 30, padding: 10, marginTop: 20, marginBottom: 20, textAlign: 'left' }}>
                                    <div>
                                        <i style={{ fontSize: 18, verticalAlign: 'middle' }} className='material-icons'>error</i> <span style={{ fontSize: 11, fontWeight: 500 }}>
                                            {this.dictionary.financiar.introduClienti}</span>
                                    </div>
                                    <div>
                                        <i style={{ fontSize: 18, verticalAlign: 'bottom', cursor: "pointer" }} className='material-icons'>clear</i>
                                    </div>

                                </div>


                            </Grid>

                        }

                        {/* {this.state.adaugaClient &&

                            <Grid item style={{ textAlign: 'left', paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                <div style={{ display: 'flex', justifyContent: "space-between", backgroundColor: 'rgb(114 227 254)', borderRadius: 30, padding: 10, marginTop: 20, marginBottom: 20, textAlign: 'left' }}>
                                    <div>
                                        <i style={{ fontSize: 18, verticalAlign: 'middle' }} className='material-icons'>error</i> <span style={{ fontSize: 11, fontWeight: 500 }}>
                                            {this.dictionary.financiar.adaugareClientMesaj}</span>
                                    </div>
                                    <div>
                                        <i style={{ fontSize: 18, verticalAlign: 'bottom', cursor: "pointer" }} className='material-icons'>clear</i>
                                    </div>

                                </div>


                            </Grid>

                        } */}
                    </Grid>
                </Grid>
            </div>
        );
    }
}